import { CircularProgress } from "@material-ui/core";
import React from "react";

const FullScreenLoader = () => {
  return (
    <>
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "rgba(0, 0, 0, 0.26)",
          backdropFilter: "blur(4px)",
        }}
      >
        <div
          className="fullscreen-loader-div loader-div"
          style={{
            textAlign: "center",
          }}
        >
          <CircularProgress size="70px" color="#fff" />
          <h2>Please wait!</h2>
        </div>
      </div>
    </>
  );
};
export default FullScreenLoader;
